import * as React from 'react';
import { Image } from '@cian/ui-kit';
import * as styles from './ComplexImage.css';

interface IComplexImageProps {
  imgUrl: string;
}

export function ComplexImage({ imgUrl }: IComplexImageProps) {
  return (
    <div className={styles['image']}>
      <Image src={imgUrl} width={365} height={200} objectFit="cover" borderRadius={0} />
    </div>
  );
}
